
import Vue from 'vue'
import VueX from 'vuex'

Vue.use(VueX)

import actions from './actions'
import modules from './modules'

export default new VueX.Store({
  state: {
    /**
     * This is the user's locale.
     * @type String
     */
    locale: 'en',

    /**
     * This is the device's UUID.
     * @type String
     */
    UUID: null,

    /**
     * This is the tenant's encrypted password.
     * @type String
     */
    token: '',

    /**
     * This variable contains all the translations in JSON format.
     * @type Object
     */
    translations: require('@/Assets/translations.json'),

    /**
     * https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
     * @type IDBDatabase
     */
    db: undefined,

    /**
     * @type Number
     */
    majorAndroidVersion: 0,
  },

  getters: {
    translate: state => key => state.translations[state.locale]?.[key] ?? state.translations.en?.[key],
    fiscalCountry: (state, getters) => prop => getters['fiscalCountry/get'](prop),
  },

  mutations: {
    locale (state, v) {
      state.locale = v
    },
    UUID (state, v) {
      state.UUID = v
    },
    token (state, v) {
      state.token = v
    },
    db (state, v) {
      state.db = v
    },
    androidVersion (state, v) {
      state.majorAndroidVersion = v.versionize(1)
    },
  },

  actions,
  modules,

  strict: process.env.NODE_ENV !== 'production'
})
